"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
(function() {
  if (!customElements.get("sticky-atc-bar")) {
    let checkBarVisibility = function() {
      const stickyAtcBar = document.querySelector(".sticky-atc-bar");
      const productVisible = document.querySelector(".product .product__info-wrapper");
      let checkBarTicking = false;
      document.addEventListener("scroll", () => {
        if (!checkBarTicking) {
          requestAnimationFrame(() => {
            let productVisibleHeight = productVisible.offsetHeight / 2;
            let scrolled = document.scrollingElement.scrollTop;
            if (scrolled > productVisibleHeight && !stickyAtcBar.classList.contains("js-hidden")) {
              stickyAtcBar.classList.add("atc-visible");
            } else {
              stickyAtcBar.classList.remove("atc-visible");
            }
            checkBarTicking = false;
          });
          checkBarTicking = true;
        }
      }, { passive: true });
    }, addStickySpace = function() {
      const checkMobileStickyBar = document.querySelector(".mobile-sticky-bar ");
      const stickyAtcBar = document.querySelector(".sticky-atc-bar");
      const style = stickyAtcBar.dataset.style;
      const bottom = style == "default" || style == "default-swatches" | window.innerWidth < 750 ? 0 : 15;
      if (window.innerWidth < 750 && checkMobileStickyBar && checkMobileStickyBar.classList.contains("active")) {
        const mobileStickyBarHeight = checkMobileStickyBar.offsetHeight;
        stickyAtcBar.style.bottom = `${mobileStickyBarHeight + bottom}px`;
      } else {
        stickyAtcBar.style.bottom = `${bottom}px`;
      }
    };
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        __publicField(this, "onVariantChange", () => {
          if (!this.select) return;
          this.select.addEventListener("change", (e) => {
            this.updateMasterId(e);
            this.renderProductInfo();
          });
        });
        this.setStickyBarHeight.bind(this);
        this.parent = this.closest(".sticky-atc-bar");
        this.select = this.querySelector(".atc-product-form .select");
        this.formBtn = this.querySelector(".button-add-card");
      }
      connectedCallback() {
        this.onVariantChange();
        this.attachResizeHandler();
        this.setStickyBarHeight();
      }
      disconnectedCallback() {
        this.cleanup();
      }
      updateMasterId(e) {
        this.currentVariant = e.target.value;
      }
      renderProductInfo() {
        const requestedVariantId = this.currentVariant;
        fetch(
          `${this.dataset.url}?variant=${requestedVariantId}`
        ).then((response) => response.text()).then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const addButtonUpdated = html.querySelector(".main-product .product-form__submit");
          this.toggleAddButton(
            addButtonUpdated.hasAttribute("disabled"),
            window.variantStrings.soldOut
          );
          const priceContainer = html.querySelector(".main-product .price__container");
          this.updatePrice(priceContainer);
        }).catch((error) => {
          console.error("Error:", error);
        });
      }
      toggleAddButton(disable = true, text, modifyClass = true) {
        const addButton = this.formBtn;
        if (!addButton) return;
        const addButtonText = addButton.querySelector("span");
        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) {
            if (addButtonText) addButtonText.textContent = text;
          }
        } else {
          addButton.removeAttribute("disabled");
          if (addButtonText) addButtonText.textContent = window.variantStrings.addToCart;
        }
        if (!modifyClass) return;
      }
      updatePrice(newPrice) {
        if (!newPrice) return;
        const oldPrice = this.querySelector(".price__container");
        if (!oldPrice) return;
        const parent = oldPrice.parentNode;
        parent.replaceChild(newPrice, oldPrice);
        this.markEmptyStrike();
      }
      markEmptyStrike() {
        const wrapper = this.querySelector(".price");
        if (!wrapper) return;
        const strike = wrapper.querySelector(".price__sale .price-item--regular");
        if (!strike) return;
        const txt = (strike.textContent || "").trim();
        const isEmpty = txt.length === 0;
        strike.classList.toggle("is-empty", isEmpty);
        const spanWrap = strike.closest("span");
        if (spanWrap) {
          spanWrap.classList.toggle("is-empty", isEmpty);
          spanWrap.style.display = isEmpty ? "none" : "";
        }
        wrapper.classList.toggle("has-strike", !isEmpty);
      }
      setStickyBarHeight() {
        let height = 0;
        if (this.parent) {
          height = this.parent.offsetHeight;
        }
        document.documentElement.style.setProperty("--atc-bar-height", `${height}px`);
      }
      attachResizeHandler() {
        this.resizeObserver = new ResizeObserver(() => this.setStickyBarHeight());
        this.resizeObserver.observe(this);
        window.addEventListener("resize", () => {
          this.setStickyBarHeight.call(this);
        });
      }
      cleanup() {
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
      }
    }
    customElements.define("sticky-atc-bar", StickyAtcBar);
    document.addEventListener("DOMContentLoaded", checkBarVisibility);
    document.addEventListener("shopify:section:load", checkBarVisibility);
    document.addEventListener("DOMContentLoaded", addStickySpace);
    document.addEventListener("shopify:section:load", addStickySpace);
    window.addEventListener("resize", addStickySpace);
    let stickySpaceTicking = false;
    window.addEventListener("scroll", () => {
      if (!stickySpaceTicking) {
        requestAnimationFrame(() => {
          addStickySpace();
          stickySpaceTicking = false;
        });
        stickySpaceTicking = true;
      }
    }, { passive: true });
    const stickyAtcSelect = document.querySelector("sticky-atc-bar .select__select");
    let atcImage = document.querySelector("sticky-atc-bar img");
    if (stickyAtcSelect) {
      stickyAtcSelect.onchange = function() {
        const getNewImage = stickyAtcSelect.options[this.selectedIndex].getAttribute("data-media");
        if (getNewImage != null && atcImage) {
          atcImage.src = getNewImage;
        }
      };
    }
  }
  if (!customElements.get("sticky-atc-variants")) {
    class StickyAtcVariants extends HTMLElement {
      constructor() {
        super();
        this.handleSwatchClick = this.handleSwatchClick.bind(this);
        this.handleSwatchKeydown = this.handleSwatchKeydown.bind(this);
        this.addActiveState = this.addActiveState.bind(this);
        this.checkCurrentVariant = this.checkCurrentVariant.bind(this);
      }
      connectedCallback() {
        this.init();
      }
      disconnectedCallback() {
        this.cleanup();
      }
      init() {
        var _a;
        this.productCard = this.closest("sticky-atc-bar");
        if (!this.productCard) return;
        this.url = this.productCard.dataset.url || "";
        this.select = this.productCard.querySelector(".select__select");
        this.cardColorSwatches = [...this.querySelectorAll(".card-variant")];
        if (!this.cardColorSwatches.length || !this.select) return;
        this.currentId = this.select.value || ((_a = this.cardColorSwatches[0]) == null ? void 0 : _a.dataset.variantId);
        this.cardColorSwatches.forEach((swatch) => {
          swatch.addEventListener("click", this.handleSwatchClick);
          swatch.addEventListener("keydown", this.handleSwatchKeydown);
        });
        this.addActiveState();
      }
      handleSwatchClick(event) {
        event.preventDefault();
        event.stopPropagation();
        const swatch = event.currentTarget;
        this.updateActiveSwatch(swatch);
      }
      handleSwatchKeydown(event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          const swatch = event.currentTarget;
          this.updateActiveSwatch(swatch);
        }
      }
      updateActiveSwatch(swatch) {
        const { variantId } = swatch.dataset;
        if (!variantId || this.checkCurrentVariant(variantId)) return;
        const matchingOption = Array.from(this.select.options).find(
          (option) => option.value === variantId
        );
        if (matchingOption) {
          this.select.value = variantId;
          this.select.dispatchEvent(new Event("change", { bubbles: true }));
        }
        this.addActiveState();
      }
      addActiveState() {
        let foundActive = false;
        this.cardColorSwatches.forEach((swatch) => {
          const { variantId } = swatch.dataset;
          if (variantId === this.select.value && !foundActive) {
            swatch.classList.add("active");
            foundActive = true;
          } else {
            swatch.classList.remove("active");
          }
        });
      }
      checkCurrentVariant(id) {
        if (this.currentId === id) {
          return true;
        }
        this.currentId = id;
        return false;
      }
      cleanup() {
        this.cardColorSwatches.forEach((swatch) => {
          swatch.removeEventListener("click", this.handleSwatchClick);
          swatch.removeEventListener("keydown", this.handleSwatchKeydown);
        });
      }
    }
    customElements.define("sticky-atc-variants", StickyAtcVariants);
  }
  const stickyAtcBtn = document.querySelector(".sticky-atc-bar__close");
  if (stickyAtcBtn) {
    const addOnClickHandler = () => {
      const stickyAtcBar = document.querySelector(".sticky-atc-bar");
      if (!stickyAtcBar) return;
      stickyAtcBtn.addEventListener("click", () => {
        stickyAtcBar.classList.add("js-hidden");
        stickyAtcBar.classList.remove("atc-visible");
      });
    };
    addOnClickHandler();
  }
})();
